/**
 * SubscriptionAnotherAmountCtrl controller
 * Add/edit category sets
 */

import { AMOUNT_TYPES } from 'app/core/constants'

/**
 * SubscriptionAnotherAmountCtrl controller
 *
 * @class SubscriptionAnotherAmountCtrl
 * @memberof mwApp/packages
 * @see mwApp/packages
 *
 * @ngdoc controller
 * @name mwApp/packages.controller:SubscriptionAnotherAmountCtrl
 */
/* @ngInject */
export default function SubscriptionAnotherAmountCtrl ($uibModalInstance, Amount, subscription) {
  var vm = this

  /**
   * Amount
   *
   * @memberof mwApp/packages.controller:SubscriptionAnotherAmountCtrl
   * @type {models.Amount}
   */
  vm.amount = new Amount({
    amountType: subscription.subscriptionType !== 'Subscription' ? 'EXTRA_CHARGE' : 'EXTRA_DEVICE'
  })

  /**
   * Amount types
   *
   * @memberof mwApp/packages.controller:AddSubscriptionSettingsCtrl
   * @type {Object}
   */
  vm.amount_types = angular.copy(AMOUNT_TYPES)

  // cleanup amount types
  delete vm.amount_types.PRICE
  if (subscription.subscriptionType !== 'Subscription') {
    delete vm.amount_types.EXTRA_DEVICE
  }

  /**
   * Changing amount validation depending on amount type
   *
   * @memberof mwApp/packages.controller:SubscriptionAnotherAmountCtrl
   */
  vm.onTypeChange = function () {
    vm.maxAmountValidation = vm.amount.amountType === 'TAX_VAT' ? 99.99 : 99999.99
  }

  /**
   * Submit form
   *
   * @memberof mwApp/packages.controller:SubscriptionAnotherAmountCtrl
   */
  vm.submit = function () {
    $uibModalInstance.close(vm.amount)
  }

  /**
   * Cancel, close form
   *
   * @memberof mwApp/packages.controller:SubscriptionAnotherAmountCtrl
   */
  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel')
  }
}
